import { DiscoverRoutes } from './type'

export const DiscoverPath = {
  root: DiscoverRoutes.root,
  capture: `${DiscoverRoutes.root}/${DiscoverRoutes.capture}`,
  connect: `${DiscoverRoutes.root}/${DiscoverRoutes.connect}`,
  convert: `${DiscoverRoutes.root}/${DiscoverRoutes.convert}`,
  care: `${DiscoverRoutes.root}/${DiscoverRoutes.care}`,
}
